import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type * as React from 'react';
import { Button } from 'react-bootstrap';

/**
 * Props for the PageHeader component.
 */
export type PageHeaderProps = {
  /** Optional handler invoked when the settings button is clicked. */
  onSettingsClick?: () => void;
  children: React.ReactNode;
};

/**
 * Page header with a title and optional settings button.
 *
 * @param children Text displayed as the page heading.
 * @param onSettingsClick Handler for the settings button; button is rendered only when provided.
 */
export const PageHeader = ({ children, onSettingsClick }: PageHeaderProps) => {
  return (
    <>
      {onSettingsClick && (
        <Button
          type="button"
          variant="outline-secondary"
          size="sm"
          className="float-end"
          onClick={onSettingsClick}
        >
          <FontAwesomeIcon icon={faCog} />
        </Button>
      )}

      <h4 className="mb-3 fw-bold">{children}</h4>
    </>
  );
};
